import { render, staticRenderFns } from "./CalcFormItem.vue?vue&type=template&id=8cb18050&"
import script from "./CalcFormItem.vue?vue&type=script&lang=js&"
export * from "./CalcFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CalcFormItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports